import React, { useState } from "react";
import "./layouts.scss";
import upiicon from "./images/p_type_upi.svg";
import paytm from "./images/p_type_paytm.svg";
import gpay from "./images/p_type_gpay.svg";
import phonepay from "./images/p_type_phonePe.svg";
import cardicon from "./images/card-icon.svg";
import netbanking from "./images/net-banking-icon.svg";
import wallet from "./images/wallet-icon.svg";
import paylater from "./images/pay-later-icon.svg";
import RazorpayModule from "./Razorpay";

const PreRazorpay = (props) => {
  const [paymentMethod, setPaymentMethod] = useState("upi");
  const [paymentFrom, setPaymentFrom] = useState("upi");
  const orderAmount = props?.orderAmount;
  const orderDetails = props?.orderDetails;
  return (
    <>
      <header className="custom-modal-header-kl">
        <div className="custom-modal-title-kl">Payments</div>
        <button type="button" onClick={() => { props?.setOpenRazorpay() }} className="close-icon-kl"></button>
      </header>
      <div className="custom-modal-body-kl">
        <div className="main-content-wrapper-kl">
          <h4 className="pre-razorpay-title-kl">SELECT PAYMENT METHOD</h4>
          <div
            className="card- box-card-shadow- razorpay-card-kl"
          >
            <div onClick={() => {
              setPaymentMethod("upi")
              setPaymentFrom("upi")
            }} className="razorpay-card-container-kl">
              <div className="checkbox">
                <input
                  type="radio"
                  value="upi"
                  checked={paymentFrom === "upi"}
                  name="radio"
                />
                <span
                  className="checkmark"
                ></span>
              </div>
              <img src={upiicon} className="upi-icon-kl" alt="Upi Logo" />
              <div>
                <p className="card-heading-kl">UPI</p>
                <img src={paytm} className="paytmicon" alt="Paytm Logo" />
                <img src={gpay} className="gpayicon" alt="Gpay Logo" />
                <img
                  src={phonepay}
                  className="phonepayicon"
                  alt="PhonePe Logo"
                />
                <span className="more-text-kl"> & More</span>
              </div>
            </div>
          </div>
        </div>
        <div className="transaction-wrapper-kl">
          <div className="transaction-title-kl">0% transaction fees applicable</div>
          <ul className="transaction-list-kl">
            <li className="transaction-items-kl">
              <span>Amount entered</span>{" "}
              <span>₹ {orderAmount?.toFixed(2)}</span>
            </li>
            <li className="transaction-items-kl">
              <span>Transaction fees</span> <span>₹ 0</span>
            </li>
            <li className="transaction-items-kl">
              <span>
                Final amount
              </span>
              <span>
                ₹ {orderAmount?.toFixed(2)}
              </span>
            </li>
          </ul>
          <div className="bonus-application-kl">
            <span>**</span>Bonus applicable as per offer on Amount entered
          </div>
        </div>
        <div className="select-payment-mode-card-kl">
          <div
            className="select-payment-mode-list-kl"
          >
            <div onClick={() => {
              setPaymentMethod("other")
              setPaymentFrom("card")
            }} className="select-payment-mode-items-kl">
              <div className="checkbox">
                <input
                  value="other"
                  type="radio"
                  checked={paymentFrom === "card"}
                  name="radio"
                />
                <span
                  className="checkmark"
                ></span>
              </div>
              <img src={cardicon} className="card-icon-kl" alt="Card Logo" />
              <div>
                <div className="card-heading-kl">Card</div>
                <div className="bottom-text-kl">
                  Visa, Mastercards, RuPay and maestro
                </div>
              </div>
            </div>
            <div onClick={() => {
              setPaymentMethod("other")
              setPaymentFrom("net")
            }} className="select-payment-mode-items-kl">
              <div className="checkbox">
                <input
                  value="other"
                  type="radio"
                  checked={paymentFrom === "net"}
                  name="radio"
                />
                <span
                  className="checkmark"
                ></span>
              </div>
              <img src={netbanking} className="card-icon-kl" alt="Card Logo" />
              <div>
                <div className="card-heading-kl">Netbanking</div>
                <div className="bottom-text-kl">All indian banks</div>
              </div>
            </div>
            {/* <div onClick={() => {
              setPaymentMethod("other")
              setPaymentFrom("wallet")
            }} className="select-payment-mode-items-kl">
              <div className="checkbox">
                <input
                  value="other"
                  type="radio"
                  checked={paymentFrom === "wallet"}
                  name="radio"
                />
                <span
                  className="checkmark"
                ></span>
              </div>
              <img src={wallet} className="card-icon-kl" alt="Card Logo" />
              <div>
                <div className="card-heading-kl">Wallet</div>
                <div className="bottom-text-kl">Mobikwik & More </div>
              </div>
            </div>
            <div onClick={() => {
              setPaymentMethod("other")
              setPaymentFrom("paylater")
            }} className="select-payment-mode-items-kl">
              <div className="checkbox">
                <input
                  value="other"
                  type="radio"
                  checked={paymentFrom === "paylater"}
                  name="radio"
                />
                <span
                  className="checkmark"
                ></span>
              </div>
              <img src={paylater} className="card-icon-kl" alt="Card Logo" />
              <div>
                <div className="card-heading-kl">Pay Later</div>
                <div className="bottom-text-kl">Simpl & More</div>
              </div>
            </div> */}
          </div>
        </div>
        <div className="transaction-wrapper-kl">
          <div className="transaction-title-kl">2% transaction fees applicable</div>
          <ul className="transaction-list-kl">
            <li className="transaction-items-kl">
              <span>Amount entered </span>{" "}
              <span>₹ {orderAmount?.toFixed(2)}</span>
            </li>
            <li className="transaction-items-kl">
              <span>Transaction fees</span>{" "}
              <span>₹ {parseFloat((orderAmount * 2) / 100)?.toFixed(2)}</span>
            </li>
            <li className="transaction-items-kl">
              <span>Final amount </span>{" "}
              <span>₹ {(orderAmount * 1.02).toFixed(2)}</span>
            </li>
          </ul>
          <p className="bonus-application-kl">
            <span>**</span>Bonus applicable as per offer on Amount entered
          </p>
        </div>
        <RazorpayModule
          orderDetails={orderDetails}
          paymentMethod={paymentMethod}
          transactionFee={paymentMethod === "other" ? (orderAmount * 2) / 100 : 0}
          orderAmount={orderAmount}
          couponId={props.couponId ? props?.couponId : null}
          setOpenRazorpay={props.setOpenRazorpay}
          onPaymentResponse={props.onPaymentResponse}
        />
      </div>
    </>
  );
};

export default PreRazorpay;
